let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3vaAo")).then(() => parcelRequire('4E57L'));